import { Component, OnInit, ViewChild } from '@angular/core';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';
import { AppFormat } from '../../appFormat';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IOferta } from 'src/app/interfaces/oferta';
import { ProductService } from 'src/app/services/product.service';
import { IOption } from '../../interfaces/option';

import {
  faChevronLeft,
  faPlus,
  faEdit,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-product-offers',
  templateUrl: './product-offers.component.html',
  styleUrls: ['./product-offers.component.scss'],
  host: { class: 'w100 dflex fcolumn' },
})
export class ProductOffersComponent implements OnInit {
  public displayedColumns: string[] = [
    'preco',
    'validade_inicial',
    'validade_final',
    'comprando',
    'status',
    'acoes',
  ];

  public displayedSimpleColumns: string[] = [
    'preco',
    'comprando',
    'validade_inicial',
    'acoes',
  ];

  public faPlus = faPlus;
  public faTimesCircle = faTimesCircle;
  public faEdit = faEdit;
  public faChevronLeft = faChevronLeft;

  public dataSource = new MatTableDataSource<IOferta>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  private params!: {};

  public length!: number | undefined;
  public pageSize!: number | undefined;
  public pageIndex: number = 0;
  public product_id: number = 0;

  public showModal: boolean = false;

  public minDate = new Date();
  public startDate = new Date();

  public normal_price = null;

  public oferta_off: number = 0;

  public offerFrm: FormGroup;

  public oferta_id: FormControl;
  public oferta_preco: FormControl;
  public oferta_obs: FormControl;
  public oferta_validade_inicial: FormControl;
  public oferta_validade_final: FormControl;
  public oferta_validade_inicial_hora: FormControl;
  public oferta_validade_final_hora: FormControl;
  public option_validade_inicial: FormControl;
  public option_validade_final: FormControl;
  public oferta_max_pr_cliente: FormControl;
  public oferta_comprando: FormControl;
  public oferta_multiplo: FormControl;

  public permanencia_inicio: IOption[] = [];
  public permanencia_fim: IOption[] = [];

  public style_simple: boolean = false;

  constructor(private _productService: ProductService) {
    this.params = {};

    this.length = 0;
    this.pageSize = 10;
    this.pageIndex = 0;

    let option_hoje = { text: 'Hoje', value: 'H' };
    this.permanencia_inicio.push(option_hoje);

    let option_nodia = { text: 'No dia', value: 'D' };
    this.permanencia_inicio.push(option_nodia);
    this.permanencia_fim.push(option_nodia);
  }

  ngOnInit(): void {
    this.createFormControls();
    this.createForm();
  }

  createFormControls() {
    //
    this.oferta_id = new FormControl(null);
    this.oferta_preco = new FormControl('');
    this.oferta_obs = new FormControl('');
    this.oferta_validade_inicial = new FormControl('');
    this.oferta_validade_final = new FormControl('');
    this.oferta_max_pr_cliente = new FormControl(null);
    this.oferta_comprando = new FormControl(null);
    this.oferta_multiplo = new FormControl('');

    this.oferta_validade_inicial_hora = new FormControl('00:00:00');
    this.oferta_validade_final_hora = new FormControl('23:59:59');

    //
    this.option_validade_inicial = new FormControl('');
    this.option_validade_final = new FormControl('');
  }

  clearFrom() {
    //
    this.oferta_id.setValue(null);
    this.oferta_preco.setValue('');
    this.oferta_obs.setValue('');
    this.oferta_validade_inicial.setValue('');
    this.oferta_validade_final.setValue('');
    this.oferta_max_pr_cliente.setValue(null);
    this.oferta_comprando.setValue(null);
    this.oferta_multiplo.setValue('');

    this.oferta_validade_inicial_hora.setValue('00:00:00');
    this.oferta_validade_final_hora.setValue('23:59:59');

    //
    this.option_validade_inicial.setValue('');
    this.option_validade_final.setValue('');
  }

  createForm() {
    this.offerFrm = new FormGroup({
      oferta_id: this.oferta_id,
      oferta_preco: this.oferta_preco,
      oferta_obs: this.oferta_obs,
      oferta_validade_inicial: this.oferta_validade_inicial,
      oferta_validade_final: this.oferta_validade_final,
      oferta_max_pr_cliente: this.oferta_max_pr_cliente,
      oferta_comprando: this.oferta_comprando,
      option_validade_inicial: this.option_validade_inicial,
      option_validade_final: this.option_validade_final,
      oferta_validade_inicial_hora: this.oferta_validade_inicial_hora,
      oferta_validade_final_hora: this.oferta_validade_final_hora,
      oferta_multiplo: this.oferta_multiplo,
    });
  }

  public clear(): void {
    this.dataSource = new MatTableDataSource<IOferta>([]);
    this.clearFrom();
  }

  public loadData(product_id: number) {
    this.product_id = product_id;

    this.getOffers();
  }

  getOffers() {
    this.params = {};

    if (this.pageSize && this.pageSize > 0) {
      this.params = { ...this.params, per_page: this.pageSize };
    }

    if (this.pageIndex > 0) {
      this.params = { ...this.params, page: this.pageIndex + 1 };
    }

    this._productService
      .getOffers(this.product_id, this.params)
      .subscribe((res) => {
        if (res.success) {
          this.dataSource = new MatTableDataSource<IOferta>(res.offers);

          //
          this.length = res.total;
          this.pageSize = res.per_page;
        }
      });
  }

  handlePageEvent(ev: PageEvent) {
    this.pageIndex = ev.pageIndex;
    this.pageSize = ev.pageSize;

    this.getOffers();
  }

  setNormalPrice(price: number) {
    this.normal_price = price;
  }

  setSimpleStyle() {
    this.style_simple = true;
  }

  updatePerc() {
    if (
      this.normal_price &&
      this.oferta_preco.value != undefined &&
      this.normal_price > 0
    ) {
      if (parseFloat(this.normal_price) > parseFloat(this.oferta_preco.value)) {
        this.oferta_off = parseFloat(
          (
            100 -
            (parseFloat(this.oferta_preco.value) * 100) /
              parseFloat(this.normal_price)
          ).toFixed(0)
        );
      } else {
        this.oferta_off = 0;
      }
    }

    this.onChangeDetail();
  }

  onChangeDetail() {}

  selectedDTInicio() {
    if (this.option_validade_inicial.value == 'H') {
      this.oferta_validade_inicial.setValue(AppFormat.nowUTCMoment());
      //this.oferta_validade_inicial.setValue(new Date())
    }
    this.onChangeDetail();
  }

  onAddNewOffer() {
    //
    this.clearFrom();
    this.showModal = true;
  }

  onEditOffer(oferta: IOferta) {
    this.clearFrom();

    this.oferta_id.setValue(oferta.idoferta);
    this.oferta_preco.setValue(oferta.preco);

    this.oferta_obs.setValue(oferta.obs);

    this.oferta_multiplo.setValue(
      oferta.multiplo == null ? '' : oferta.multiplo
    );

    if (oferta.comprando && oferta.comprando > 0) {
      this.oferta_comprando.setValue(oferta.comprando);
    } else {
      this.oferta_comprando.setValue(null);
    }

    if (this.normal_price) {
      this.oferta_off = parseFloat(
        (100 - (oferta.preco * 100) / this.normal_price).toFixed(0)
      );
    }

    let validade_inicial = oferta.validade_inicial.split(' ');
    if (validade_inicial.length > 0) {
      this.oferta_validade_inicial.setValue(
        AppFormat.dateYMDUTCMoment(validade_inicial[0])
      );
      this.oferta_validade_inicial_hora.setValue(validade_inicial[1]);
    }

    let validade_final = oferta.validade_final.split(' ');
    if (validade_final.length > 0) {
      this.oferta_validade_final.setValue(
        AppFormat.dateYMDUTCMoment(validade_final[0])
      );
      this.oferta_validade_final_hora.setValue(validade_final[1]);
    }

    this.option_validade_inicial.setValue('D');
    this.option_validade_final.setValue('D');

    this.showModal = true;
  }

  onDeleteOffer(oferta: IOferta) {
    Swal.fire({
      title: 'Você deseja realmente apagar a promoção?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Apagando...',
          icon: 'info',
          showCancelButton: false,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        this._productService
          .deleteOffer(this.product_id, oferta.idoferta)
          .subscribe((res) => {
            if (res['success']) {
              this.onCancel();
              this.getOffers();
              Swal.fire(
                'Apagado!',
                'A promoção do produto foi removida',
                'success'
              );
            } else {
              Swal.fire('Ops!', 'Ocorreu um erro ao tentar apagar.', 'error');
            }
          });
      }
    });
  }

  onCancel() {
    this.showModal = false;
  }

  ofertaValid() {
    let has = true;

    let msg = [];

    if (
      (this.oferta_preco.invalid &&
        (this.oferta_preco.dirty || this.oferta_preco.touched)) ||
      this.oferta_preco.value == '' ||
      this.oferta_preco.value == null ||
      this.oferta_preco.value == 0
    ) {
      msg.push('Você precisa preencher o preço promocional!');
      has = false;
    }

    if (
      (this.oferta_validade_inicial.invalid &&
        (this.oferta_validade_inicial.dirty ||
          this.oferta_validade_inicial.touched)) ||
      this.oferta_validade_inicial.value == '' ||
      this.oferta_validade_inicial.value == null
    ) {
      msg.push('Você precisa preencher uma data inicial da oferta válida!');
      has = false;
    }

    if (
      (this.oferta_validade_final.invalid &&
        (this.oferta_validade_final.dirty ||
          this.oferta_validade_final.touched)) ||
      this.oferta_validade_final.value == '' ||
      this.oferta_validade_final.value == null
    ) {
      msg.push('Você precisa preencher uma data final da oferta válida!');
      has = false;
    }

    if (msg.length > 0) {
      Swal.fire('Ops!', msg.join('<br>'), 'error');
    }

    return has;
  }

  onSubmit() {
    if (this.ofertaValid()) {
      let dtinicial,
        dtfinal = '';
      if (
        this.oferta_validade_inicial.value != null &&
        typeof this.oferta_validade_inicial.value === 'object'
      ) {
        dtinicial = this.oferta_validade_inicial.value.format('YYYY-MM-DD');
      } else {
        dtinicial = this.oferta_validade_inicial.value;
      }
      if (
        this.oferta_validade_final.value != null &&
        typeof this.oferta_validade_final.value === 'object'
      ) {
        dtfinal = this.oferta_validade_final.value.format('YYYY-MM-DD');
      } else {
        dtfinal = this.oferta_validade_final.value;
      }

      //
      let data = {
        oferta_id: this.oferta_id.value,
        oferta_preco: this.oferta_preco.value,
        oferta_validade_inicial: dtinicial,
        oferta_validade_inicial_hora: this.oferta_validade_inicial_hora.value,
        oferta_validade_final: dtfinal,
        oferta_validade_final_hora: this.oferta_validade_final_hora.value,
        oferta_obs: this.oferta_obs.value,
        oferta_comprando: this.oferta_comprando.value,
        oferta_multiplo: this.oferta_multiplo.value,
      };

      this._productService.storeOffer(this.product_id, data).subscribe(
        (res) => {
          if (res['success']) {
            this.onCancel();
            this.getOffers();
            this.saveComplete();
          } else {
            this.saveError();
          }
        },
        (error) => {
          this.saveError();
        }
      );
    }
    return null;
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplete() {
    Swal.fire('Salvo!', 'A promoção do produto foi salvo', 'success');
  }

  saving() {
    Swal.fire({
      title: 'Salvando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }
}
